// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"329b4da1","453":"9565eb5e","455":"ee45bf9a","806":"0af71893","977":"d41fea1e"}[chunkId] + ".chunk.js";
};